import { ReactElement } from 'react';
import { generatePath, Route, useParams } from 'react-router-dom';

import { createRouteConfig } from 'modules/common/utils/createRouteConfig';
import { LiquidStakingTab } from 'modules/liquidStaking/const';

import { Dashboard } from './screens/Dashboard';

export const DEPRECATED_STAKING_PATH = `/deprecated/liquid-staking`;
export const DEPRECATED_STAKING_TAB_PATH = `${DEPRECATED_STAKING_PATH}/:tab`;

export const DeprecatedLiquidStakingRoutesConfig = createRouteConfig(
  {
    dashboard: {
      path: DEPRECATED_STAKING_TAB_PATH,
      generatePath: (tab: LiquidStakingTab = LiquidStakingTab.Unstake) =>
        generatePath(DEPRECATED_STAKING_TAB_PATH, { tab }),
      useParams: (): { tab?: LiquidStakingTab } => {
        const data = useParams<{ tab: LiquidStakingTab }>();
        const { tab } = data;

        return { tab: tab || LiquidStakingTab.Unstake };
      },
    },
  },
  DEPRECATED_STAKING_TAB_PATH,
);

export function getDeprecatedLiquidStakingRoutes(): ReactElement {
  return (
    <Route
      element={<Dashboard />}
      path={DeprecatedLiquidStakingRoutesConfig.dashboard.path}
    />
  );
}
